/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export interface SendCuraiMessageRequest {
  /** The body of the message to send */
  message?: string | null;
  /** List of attachment IDs to send with the message */
  attachment_ids?: string[] | null;
}
